//Author : Kavitha Sri

import React, { InputHTMLAttributes } from "react";
import { Button } from "reactstrap";

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    /**@param {any} type defines which type of input control to display */
    type: any;
    /** @param {any} btnClassName return the value of the button's class*/
    btnClassName: any,
    /** @param {any} iconClasssName return the value of the icon's class*/
    iconClasssName: any,
    /** @param {any} name reference of the elements*/
    name: any,
    /** @param {any} onClick is refers the clicking the function*/
    onClick?: any,
    disabled?: boolean,
    id?:any
}

export const CustomButton = React.forwardRef(({ type, name, btnClassName, iconClasssName, onClick, disabled, id }: inputProps, ref) => {

    return (
        <>
            <Button type={type} id={id} className={`btn ${btnClassName} w-xs`} onClick={onClick} disabled={disabled}><i className={`${iconClasssName}`}></i>{name}</Button>
        </>
    )
})